module.exports = "<div class=\"config-list-container container-fluid\">\n  <div class=\"rg-rules\"></div>\n  <button type=\"button\" class=\"btn btn-primary btn-add\">{{t('trafficPolicy.addRule')|e}}</button>\n</div>\n";
